<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="发票管理"
    >
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[{ Text: '全部' }, ...$base.Meeting_Invoice_Status]"
        :empty-values="[null, undefined, 0]"
        class="c-segmented"
        @change="onLoad"
      />
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showAdd = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <div class="flex gap-x-7">
        <c_cell title="会议应收款">
          <template #default>
            <c_money
              :value="state.meetingCollectedPlanStatistic?.amount"
              :key="state.meetingCollectedPlanStatistic?.amount"
              :prefix="false"
              color="#000"
            />
          </template>
        </c_cell>
        <c_cell title="会议已收款">
          <template #default>
            <c_money
              :value="state.meetingCollectedPlanStatistic?.collected_amount"
              :key="state.meetingCollectedPlanStatistic?.collected_amount"
              :prefix="false"
              color="#080"
            />
          </template>
        </c_cell>
        <c_cell title="开票审核中" class="ml-10">
          <template #default>
            <c_money
              :value="state.amountStatistic?.uncheckAmount"
              :key="state.amountStatistic?.uncheckAmount"
              :prefix="false"
              color="#ffa500"
            />
          </template>
        </c_cell>
        <c_cell title="已审核开票中">
          <template #default>
            <c_money
              :value="state.amountStatistic?.checkedAmount"
              :key="state.amountStatistic?.checkedAmount"
              :prefix="false"
              color="#ffa500"
            />
          </template>
        </c_cell>
        <c_cell title="已开票">
          <template #default>
            <c_money
              :value="state.amountStatistic?.invoiceAmount"
              :key="state.amountStatistic?.invoiceAmount"
              :prefix="false"
              color="#080"
            />
          </template>
        </c_cell>
        <c_cell title="已标记到款">
          <template #default>
            <c_money
              :value="state.amountStatistic?.receiptAmount"
              :key="state.amountStatistic?.receiptAmount"
              :prefix="false"
              color="#9932CC"
            />
          </template>
        </c_cell>
      </div>
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        class="mt-3"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="状态" label2="类型" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <c_status
                  arrName="Meeting_Invoice_Status"
                  :value="row.status"
                  :key="row.status"
                />
              </template>
              <template #bottom>
                <c_status
                  arrName="Invoice_Type"
                  :value="row.invoice_type"
                  :key="row.invoice_type"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="发票抬头"
              label2="纳税人识别号"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.invoice_title" :value2="row.tax_no" />
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="amount"
          label="开票金额"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="发票号" label2="开票日期" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.invoice_no || '-'"
              :value2="row.invoice_date || ''"
            />
          </template>
        </el-table-column>
        <el-table-column label="创建信息">
          <template #default="{ row }">
            <c_tabgroup :value2="row.create_time">
              <template #top>
                <text>
                  {{ row.add_admin_name }}
                </text>
                <text class="text-xs text-gray-400">
                  {{ "/" + row.add_department_name }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Search"
              link
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showAdd"
    title="申请开票"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showAdd = false;
        onLoad();
      }
    "
    :width="500"
  >
    <c_add
      :meeting_id="props.meeting_id"
      :meeting_bill_title="props.meeting_bill_title"
      @close="
        state.showAdd = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showDetail"
    title="发票详情"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    :width="800"
  >
    <c_detail :id="state.selectId" @close="state.showDetail = false" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_invoice_page } from "@/http/meeting";

import c_add from "./Add.vue";
import c_detail from "./Detail.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number, //会议Id
    meeting_bill_title: String, //会议的单据抬头
  },
  components: {
    c_add,
    c_detail,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      meeting_invoice_page(state.params).then((res) => {
        if (res.status == 200) {
          const {
            amountStatistic,
            list,
            count,
            meetingCollectedPlanStatistic,
          } = res.data?.data;
          state.amountStatistic = amountStatistic;
          state.meetingCollectedPlanStatistic = meetingCollectedPlanStatistic;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    return { state, props, onLoad };
  },
};
</script>

<style lang="scss" scoped></style>
